<template>
<div>
  <div class="sticky">
    <h5>Liste des ressources Europeana associées à la carte {{currentMap.mapTitle}}</h5>
  </div>
  <div class="europeanaResources">
    <b-card v-for="ressource in europanaResourcesList" :key="ressource.ark" :img-src="ressource.edmPreview" img-alt="Image" img-left tag="article" class="mb-2">
      <b-card-title><a :href="ressource.guid" target="blank">{{ ressource.title }}</a></b-card-title>
      <b-card-text>
        <div id="itemDescription">
          Description: "{{ ressource.dcDescription }}"
        </div>
        <b-list-group>
          <b-list-group-item>Créateur: {{ressource.dcCreator}}</b-list-group-item>
          <b-list-group-item>Fournisseur: {{ressource.dataProvider}}</b-list-group-item>
          <b-list-group-item>Pays: {{ressource.country}}</b-list-group-item>
        </b-list-group>
      </b-card-text>
      <b-button :href="ressource.guid" target="blank" variant="primary">Lien Europeana</b-button>
    </b-card>
  </div>
</div>
</template>


<script>
import { mapGetters } from 'vuex'

export default {
  name: 'europeana-resources-for-map',
  props: ['currentMap'],
  computed: {
    ...mapGetters({
      europanaResourcesList: 'getEuropanaResourcesList'
    })
  },
  created() {
    this.$store.dispatch('findEuropeanaResourcesForMap', this.currentMap.mapIdentifier)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/commons/EuropeanaResourcesForMap.vue